import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/min';

export function isValidPhoneNumber(phoneNumber: string, countryCode: string): boolean {
  if (!phoneNumber || !countryCode) return false;

  try {
    // Convert your country code to the proper CountryCode type
    const libCountryCode = countryCode.toUpperCase() as CountryCode;
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, libCountryCode);
    return parsedNumber ? parsedNumber.isValid() : false;
  } catch (e) {
    return false;
  }
}
